var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.13625V11.595C1 11.9676 1.14048 12.325 1.39052 12.5885C1.64057 12.852 1.97971 13 2.33333 13H10.3333C10.687 13 11.0261 12.852 11.2761 12.5885C11.5262 12.325 11.6667 11.9676 11.6667 11.595V9.13625M6.33383 8.96166L6.33383 1M6.33383 1L3.28621 4.04212M6.33383 1L9.38145 4.04212",
    stroke: "#1B1C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a469a4331028a0bc3fa0a662fb1619aa.svg";
export { ForwardRef as ReactComponent };